import { Link } from "react-router-dom";
import logo from "../assets/images/logo.jpg";

export default function VerifyNoticePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8">
        {/* Logo at the top */}
        <div className="flex justify-center mb-4">
          <img
            src={logo}
            alt="Company Logo"
            className="h-16 w-16 object-cover rounded-full"
          />
        </div>

        <h1 className="text-2xl font-bold text-center mb-4 text-[#007AFF]">
          Verify Your Email
        </h1>

        <p className="text-center text-gray-600 mb-6">
          A verification link has been sent to your email address. Please check
          your inbox (and spam folder) to activate your account.
        </p>

        <div className="flex flex-col gap-4">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-[#007AFF] text-white py-3 rounded-lg font-semibold hover:bg-blue-600 transition"
          >
            Refresh Page
          </button>

          <Link
            to="/login"
            className="w-full text-center bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
          >
            Go to Login
          </Link>
        </div>

        <p className="mt-6 text-center text-gray-600 text-sm">
          Didn’t get the email?{" "}
          <span className="text-[#007AFF] font-medium">Resend Link</span>
        </p>
      </div>
    </div>
  );
}
